export default __webpack_public_path__ + "static/media/fireFN18.155bbea6.svg";